import React, { FC, useState } from "react";
import { Box, Divider, Typography, SxProps, Theme } from "@mui/material";
import {
  activeFontStyles,
  getFontStyle,
  Container,
  Dropdown,
} from "./sortByStyles";
import defaultDropdownIcon from "../../assets/drop-down.svg";
import ledgerDropdownIcon from "../../assets/customerSortByIcon.svg";
import { useRole } from "../../context/RoleContext";

type SortByProps = {
  selected: string;
  options: string[];
  setSelected: (value: string) => void;
  variant?: "seller" | "customer";
  hideOptions?: boolean;
  containerSx?: SxProps<Theme>;
  isOpen?: boolean;
  onToggle?: (open: boolean) => void;
};

const SortBy: FC<SortByProps> = ({
  options,
  selected,
  setSelected,
  variant,
  hideOptions = false,
  containerSx,
  isOpen: externalOpen,
  onToggle,
}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const [hasUserSelected, setHasUserSelected] = useState(false);

  const open = externalOpen !== undefined ? externalOpen : internalOpen;

  const handleToggle = () => {
    const newOpenState = !open;

    if (onToggle) {
      onToggle(newOpenState);
    } else {
      setInternalOpen(newOpenState);
    }
  };

  React.useEffect(() => {
    if (externalOpen === false) {
      setInternalOpen(false);
    }
  }, [externalOpen]);

  const { role } = useRole();
  const isSellerLedgerScreen =
    role === "maltora-seller" && location.pathname.includes("/ledgers");

  const isCustomerLedgerScreen =
    role === "maltora-customer" && location.pathname.includes("/ledgers");

  const dropdownIcon = isCustomerLedgerScreen
    ? ledgerDropdownIcon
    : defaultDropdownIcon;

  // Show "Sort By" if hideOptions is true & user hasn't selected anything yet
  const displayText = hideOptions
    ? hasUserSelected
      ? selected
      : "Sort By"
    : `Sort by: ${selected}`;

  return (
    <Box display={"flex"} flexDirection={"column"}>
      <Container variant={variant} onClick={handleToggle} sx={containerSx}>
        <Typography sx={getFontStyle(isSellerLedgerScreen)}>
          <span style={activeFontStyles as any}>{displayText}</span>
        </Typography>
        <img
          src={dropdownIcon}
          style={{ rotate: open ? "0deg" : "180deg" }}
          alt=""
          width="9.3px"
        />
      </Container>
      {open && (
        <Dropdown variant={variant}>
          {options.map((option, idx) => (
            <React.Fragment key={option}>
              <Typography
                sx={activeFontStyles}
                onClick={() => {
                  setSelected(option);
                  setHasUserSelected(true);
                  if (onToggle) {
                    onToggle(false);
                  } else {
                    setInternalOpen(false);
                  }
                }}
              >
                {option}
              </Typography>
              <Divider hidden={idx + 1 === options.length} sx={{ my: "5px" }} />
            </React.Fragment>
          ))}
        </Dropdown>
      )}
    </Box>
  );
};

export default SortBy;
